import React from 'react';
import PropTypes from 'prop-types';

import {withI18n} from 'spa/Components/Context';

import TabMenu from '@urbanmassage/component-library/lib/TabMenu/TabMenu';
import TabMenuItem from '@urbanmassage/component-library/lib/TabMenuItem/TabMenuItem';

import {BIO_TAB_NAME, INFO_TAB_NAME, SERVICES_TAB_NAME, REVIEWS_TAB_NAME} from 'spa/Components/Reviews/values';

@withI18n
class TherapistProfileTabs extends React.Component {
  static propTypes = {
    activeTab: PropTypes.string.isRequired,
    onChangeTab: PropTypes.func.isRequired,
    showReviewsTabMobile: PropTypes.bool,
    showServicesTab: PropTypes.bool,
    textReviewsEnabled: PropTypes.bool,
  }

  static defaultProps = {
    showReviewsTabMobile: false,
    textReviewsEnabled: true,
  }

  render() {
    const {
      activeTab,
      onChangeTab,
      showReviewsTabMobile,
      showServicesTab,
      textReviewsEnabled,
    } = this.props;
    const {i18n} = this.context;

    return (
      <TabMenu>
        <TabMenuItem
          data-tab={INFO_TAB_NAME}
          data-testid="tab-menu-item-0"
          key="tab-menu-item-0"
          active={activeTab === INFO_TAB_NAME}
          onClick={onChangeTab}
          text={i18n._x('Info', 'Therapist Single Subnavigation tab')}
        />
        {showReviewsTabMobile && (
          <TabMenuItem
            data-tab={REVIEWS_TAB_NAME}
            data-testid="tab-menu-item-1"
            key="tab-menu-item-1"
            active={activeTab === REVIEWS_TAB_NAME}
            onClick={onChangeTab}
            text={textReviewsEnabled ? i18n._x('Reviews', 'Therapist Single Subnavigation tab') : i18n._x('Ratings', 'Therapist Single Subnavigation tab')}
          />
        )}
        {showServicesTab ? (
          <TabMenuItem
            data-tab={SERVICES_TAB_NAME}
            data-testid="tab-menu-item-2"
            key="tab-menu-item-2"
            active={activeTab === SERVICES_TAB_NAME}
            onClick={onChangeTab}
            text={i18n._x('Services', 'Therapist Single Subnavigation tab')}
          />
        ) : null}
        <TabMenuItem
          data-tab={BIO_TAB_NAME}
          data-testid="tab-menu-item-3"
          key="tab-menu-item-3"
          active={activeTab === BIO_TAB_NAME}
          onClick={onChangeTab}
          text={i18n._x('Bio', 'Therapist Single Subnavigation tab')}
        />
      </TabMenu>
    );
  }
}

export default TherapistProfileTabs;



// WEBPACK FOOTER //
// ./spa/Pages/Therapists/TherapistProfileTabs.jsx